import Icon from '../components/Icon.vue'

Icon.register({"forumbee":{"width":1536,"height":1792,"paths":[{"d":"M934 150q-317 121-556 362.5t-358 560.5q-20-89-20-176 0-208 102.5-384.5t278.5-279 384-102.5q82 0 169 19zM1203 269q93 65 164 155-389 113-674.5 400.5t-396.5 676.5q-93-72-155-162 112-386 395-671t667-399zM470 1603q115-356 379.5-622t619.5-384q40 92 54 195-292 120-516 345t-343 518q-103-14-194-52zM1536 1661q-193-50-367-115-135 84-290 107 109-205 274-370.5t369-275.5q-21 152-101 284 65 175 115 370z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/forumbee.js
// module id = 0pO2
// module chunks = 1